import { createBrowserRouter, Navigate } from 'react-router-dom';

import Default from 'pages/Default';
import DeviceList from 'pages/DeviceList';
import LotoConclusionPopup from 'pages/loto-status/LotoConclusionPopup';
import NetErrorPage from 'pages/NetErrorPage';
import StatusBoard from 'pages/StatusBoard';

import SignIn from '../pages/SignIn';
import { retryLazy } from '../util/lazyUtil';
import AuthGuard from './AuthGuard';
import PingGuard from './PingGuard';
import ProtectedRoute from './ProtectedRoute';

const Mypage = retryLazy(() => import('pages/Mypage'));
const AuthConfirmPassword = retryLazy(
  () => import('pages/AuthConfirmPassword'),
  'AuthConfirmPassword',
);
const LotoConclusion = retryLazy(
  () => import('pages/loto-status/LotoConclusion'),
  'LotoConclusion',
);
const OldLoto = retryLazy(() => import('pages/loto-status/OldLoto'), 'OldLoto');
const LotoCommunication = retryLazy(
  () => import('pages/loto-status/LotoCommunication'),
  'LotoCommunication',
);
const LotoActionLog = retryLazy(
  () => import('pages/loto-status/LotoActionLog'),
  'LotoActionLog',
);
const LotoSetting = retryLazy(
  () => import('pages/loto-management/LotoSetting'),
  'LotoSetting',
);
const LotoLog = retryLazy(
  () => import('pages/loto-management/LotoLog'),
  'LotoLog',
);
const LotoPermission = retryLazy(
  () => import('pages/loto-management/LotoPermission'),
  'LotoPermission',
);
const LotoSelfPermission = retryLazy(
  () => import('pages/loto-management/LotoSelfPermission'),
  'LotoSelfPermission',
);
const LotoPermissionLog = retryLazy(
  () => import('pages/loto-management/LotoPermissionLog'),
  'LotoPermissionLog',
);
const LotoPermissionTransfer = retryLazy(
  () => import('pages/loto-management/LotoPermissionTransfer'),
  'LotoPermissionTransfer',
);
const LotoBox = retryLazy(
  () => import('pages/loto-management/LotoBox'),
  'LotoBox',
);

const UserList = retryLazy(() => import('pages/UserList'), 'UserList');
const LockerList = retryLazy(() => import('pages/LockerList'), 'LockerList');
const LockAuth = retryLazy(() => import('pages/LockAuth'), 'LockAuth');

const FactoryPosition = retryLazy(
  () => import('pages/equip-position/FactoryPosition'),
  'FactoryPosition',
);
const AreaPosition = retryLazy(
  () => import('pages/equip-position/AreaPosition'),
  'AreaPosition',
);
const ZonePosition = retryLazy(
  () => import('pages/equip-position/ZonePosition'),
  'ZonePosition',
);
const EquipmentPosition = retryLazy(
  () => import('pages/equip-position/EquipmentPosition'),
  'EquipmentPosition',
);
const ZonePopup = retryLazy(() => import('pages/ZonePopup'), 'ZonePopup');
const ShiftWorkSetting = retryLazy(
  () => import('pages/ShiftWorkSetting'),
  'ShiftWorkSetting',
);

const Setting = retryLazy(() => import('pages/Setting'), 'Setting');

const routes = createBrowserRouter([
  {
    path: 'sign-in',
    element: <SignIn />,
  },
  // {
  //   path: '/error',
  //   element: <ErrorPage />,
  // },
  {
    path: '/net-error',
    element: <NetErrorPage />,
  },
  {
    path: '/popup/loto-conclusion',
    element: <LotoConclusionPopup />,
  },
  {
    path: '/',
    element: (
      <PingGuard>
        <AuthGuard>
          <Default />
        </AuthGuard>
      </PingGuard>
    ),

    children: [
      { path: '/home/status-board', element: <StatusBoard /> },
      {
        path: '/loto-status',
        children: [
          {
            path: 'conclusion',
            element: <LotoConclusion />,
          },
          {
            path: 'longTerm',
            element: <OldLoto />,
          },
          {
            path: 'communication',
            element: <LotoCommunication />,
          },
          {
            path: 'action',
            element: <LotoActionLog />,
          },
        ],
      },
      {
        path: '/loto-management',
        children: [
          {
            path: 'permission',
            element: <LotoPermission />,
          },
          {
            path: 'setting',
            element: <LotoSetting />,
          },
          {
            path: 'box',
            element: <LotoBox />,
          },
          {
            path: 'log',
            element: <LotoLog />,
          },
          {
            path: 'permission-log',
            element: <LotoPermissionLog />,
          },
          {
            path: 'permission-transfer',
            element: <LotoPermissionTransfer />,
          },
        ],
      },
      {
        path: '/devices',
        children: [
          { path: 'device', element: <DeviceList /> },
          { path: 'factory-position', element: <FactoryPosition /> },
          { path: 'area-position', element: <AreaPosition /> },
          { path: 'zone-position', element: <ZonePosition /> },
          { path: 'equipment-position', element: <EquipmentPosition /> },
        ],
      },
      { path: '/lockers/locker', element: <LockerList /> },
      {
        path: '/admin',
        children: [
          {
            path: 'user',
            element: <UserList />,
          },
          {
            path: 'lock-permission',
            element: <LockAuth />,
          },
          // {
          //   path: '/admin/shift',
          //   element: <ShiftWorkSetting />,
          // },
        ],
      },
      {
        path: '/setting',
        element: <Setting />,
      },
      { path: '/auth-confirm', element: <AuthConfirmPassword /> },
      {
        path: '/mypage',
        element: (
          <ProtectedRoute>
            <Mypage />
          </ProtectedRoute>
        ),
      },
      { path: '/*', element: <Navigate to={'/home/status-board'} replace /> },
    ],
  },
  { path: '/popup/zone-map/:id', element: <ZonePopup /> },
]);

export default routes;
